import * as React from "react"
import * as components from "../Components"
import Fallback from "../components/Fallback"
import { graphql } from "gatsby"
import Seo from "../components/Seo"
import Layout from "../components/Layout"
import Hero from "../components/Hero"

const SpelOverzicht = ({ data, pageContext }) => {
  const pageData = data.nodeSpelOverzicht
  const mapMarkers = data.mapmarkers.nodes

  return (
    <Layout>
      <Hero
        title={pageData.relationships.field_hero.field_title_html.value}
        intro={pageData.relationships.field_hero.field_intro.processed}
        buttons={pageData.relationships.field_hero.relationships.field_cta}
      />

      {pageData.relationships.field_components.map(block => {
        const Component = components[block.__typename] || Fallback
        return (
          <Component
            mapMarkers={mapMarkers}
            key={block.id ? block.id : "undefined_key"}
            {...block}
          />
        )
      })}
    </Layout>
  )
}

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = ({ data }) => (
  <Seo
    title={
      data.nodeSpelOverzicht.relationships.field_meta_info.field_meta_title
    }
    description={
      data.nodeSpelOverzicht.relationships.field_meta_info
        .field_meta_description
    }
    metatag={data.nodeSpelOverzicht.metatag}
  />
)

export default SpelOverzicht

export const SpelOverzichtQuery = graphql`
  query MyQuerySpelOverzicht {
    nodeSpelOverzicht(status: { eq: true }) {
      id
      title
      path {
        alias
      }
      metatag {
        tag
        attributes {
          content
          href
          name
          property
          rel
        }
      }

      relationships {
        field_hero {
          ...paragraph__headerFragment
        }
        field_meta_info {
          ...paragraph__meta_infoFragment
        }
        field_components {
          ... on Node {
            ...paragraph__standoutFragment
            ...paragraph__faq_relatedFragment
            ...paragraph__image_textFragment
            ...paragraph__carouselFragment
            ...paragraph__organisation_collectionFragment
            ...paragraph__spelletjes_relatedFragment
            ...paragraph__image_collectionFragment
            ...paragraph__card_collectionFragment
            ...paragraph__videoFragment
            ...paragraph__carousel_cardsFragment
            ...paragraph__verenigingen_mapFragment
          }
        }
      }
    }
    mapmarkers: allNodeVereniging(filter: { status: { eq: true } }) {
      nodes {
        id
        title
        field_straat_nr
        field_postcode_gemeente
        field_latitude
        field_longitude
        relationships {
          field_type_vereniging {
            name
          }
        }
      }
    }
  }
`
